<script context="module" lang="ts">
    import { getContext } from "svelte";
    import type { EditorLayout, PanelId, PanelData } from "./editor";
    import { get, type Writable } from "svelte/store";

    const CONTEXT_KEY = "editor-layout"; //Symbol("editor-layout");
    type Context = {
        layout: EditorLayout;
        dragging: Writable<PanelId | null>;
        panel: (id: string | null) => PanelData | null;
        writableState: <T>(key: string, value: T) => Writable<T>;
    };

    export function getLayout(): Context {
        return getContext<Context>(CONTEXT_KEY);
    }
</script>

<script lang="ts">
    import { setContext } from "svelte";
    import { writable } from "svelte/store";

    export let layout: EditorLayout;

    const dragging = writable<PanelId | null>(null);

    setContext(CONTEXT_KEY, {
        layout,
        panel: (id: string) => {
            return get(layout.panels)[id] ?? null;
        },
        dragging,
    });
</script>

<slot/>